module.exports = __webpack_public_path__ + "media/images/results_dates_prev-6737b58facf1a072e2c3a912e2b15f17.svg";